<template>
    <div
        v-if="chips.length > 0 || edit"
        :id="block.id || `${block.type}-${uid}`"
        class="mt-6 mt-md-8 mt-lg-10"
    >
        <div class="page-container">

            <div
                v-if="edit"
                class="edit"
            >
                <button
                    class="btn-bg btn-lg rounded icon-ic-pencil-outline elevate edit-btn"
                    @click="$emit('openChipsEditor')"
                />
            </div>

            <div v-if="title.text || description.text" class="row">
                <div class="col-12 col-lg-10 offset-lg-1 ta-center">

                    <h2 v-if="title.text" class="h4 h3-sm h2-md mt-0 mb-2 mb-sm-3 mb-md-4" :class="title.class" v-html="title.text" />

                    <div
                        v-if="description.text"
                        class="desc mb-2 mt-sm-n1 mb-sm-3 mt-md-n2 mb-md-4"
                        :class="description.class"
                        v-html="description.text"
                    />

                </div>
            </div>

            <div
                class="items"
                :class="content.class"
            >
                <Chip
                    v-for="(item, i) in chips"
                    :key="`chip-${i}`"
                    class="item lg"
                    :class="item.class"
                >
                    <template v-slot:text>
                        {{ item.text }}
                    </template>
                </Chip>
            </div>

        </div>
    </div>
</template>


<script>
    let uid = 0;

    import Chip from '~/components/chips/Chip.vue';

    import blockPropertyObject from '~/mixins/course-landing/blockPropertyObject.js';

    export default {
        props: {
            block: Object,
            edit:  Boolean,
        },

        components: {
            Chip,
        },

        mixins: [
            blockPropertyObject,
        ],

        data () {
            uid++;

            return {
                uid,
            };
        },

        computed: {
            title () {
                return this.blockPropertyObject(this.block.title, 'text');
            },

            description () {
                return this.blockPropertyObject(this.block.description, 'text');
            },

            content () {
                return this.blockPropertyObject(this.block.content, 'chips');
            },

            chips () {
                if (!this.content.chips) return [];

                let chips = [];

                this.content.chips.forEach(chip => {
                    let obj = this.blockPropertyObject(chip, 'text');

                    if (obj) chips.push(obj);
                });

                return chips;
            },
        },
    }
</script>


<style lang="postcss" scoped>
    .desc {
        @media screen and (min-width: 576px) {
            font-size:   19px;
            line-height: 1.263158;
        }

        @media screen and (min-width: 992px) {
            font-size:   24px;
            line-height: 1.166667;
        }
    }

    .items {
        margin: -4px;

        display:         flex;
        flex-flow:       row wrap;
        justify-content: center;

        @media screen and (min-width: 992px) {
            margin: -8px;
        }
    }

    .item {
        box-shadow: inset 0 0 0 2px var(--color-cases-gray-4);

        margin:        4px;
        border-radius: 9000px;
        padding:       4px 16px;

        @media screen and (min-width: 992px) {
            font-size:   20px;
            line-height: 1.6;

            margin:  8px;
            padding: 6px 24px;
        }
    }

    .edit {
        position: relative;
    }

    .edit-btn {
        position: absolute;
        top:      -6px;
        right:    -8px;
        z-index:  10;
    }
</style>
